import React, { useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useSelector } from 'react-redux';
import { assetNamesSelector } from '../../features/assets/assetsSlice';
import { Grid } from '@mui/material';


const VehicleAutoComplete = ({ vehicle, onVehicleSelect, assetId, onAssetIdChange }) => {

    const assetNames = useSelector(assetNamesSelector);
    const assetOptions = assetNames ? Object.keys(assetNames) : [];
    assetOptions.push("");

    /*useEffect(() => {
        //console.log("AssetOptions", assetNames, assetOptions);
    }, [assetNames, assetOptions])*/

    return (
        <Grid item>
            <Autocomplete
                id="vehicle"
                style={{ width: 200 }}
                options={assetOptions}
                getOptionLabel={(option) => option ? assetNames[option]?.regn : ""}
                value={assetId}
                onChange={onAssetIdChange}
                inputValue={vehicle}
                onInputChange={onVehicleSelect}
                renderInput={(params) => <TextField variant="standard" {...params} label="Vehicle" />}
            />
        </Grid>
    );
}

export default VehicleAutoComplete;